import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
import MusicVideoIcon from "@mui/icons-material/MusicVideo";
import QueueIcon from "@mui/icons-material/Queue";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { StyledCardAdd, StyledMenu } from "./styles";
import { TrackMenuButtonProps } from "./types";

export const TrackMenuButton: React.FC<TrackMenuButtonProps> = ({
  handleAddTrack,
  handleAddTracks,
  isMultipleFileUploadButton,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <StyledCardAdd
        id="step-1"
        aria-controls={open ? "styled-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        style={{ marginTop: 0 }}
        startIcon={<QueueIcon sx={{ marginBottom: 0.5 }} />}
      >
        Add {isMultipleFileUploadButton ? "Files" : "Music"}
      </StyledCardAdd>
      <StyledMenu
        id="styled-menu"
        MenuListProps={{
          "aria-labelledby": "styled-card-add",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          sx={{ backgroundColor: "inherit" }}
          onClick={() => {
            handleClose();
            handleAddTrack();
          }}
          disableRipple
        >
          <MusicVideoIcon />
          Single {isMultipleFileUploadButton ? "File" : "Track"}
        </MenuItem>
        <MenuItem
          sx={{ backgroundColor: "inherit" }}
          onClick={() => {
            handleClose();
            handleAddTracks();
          }}
          disableRipple
        >
          <LibraryMusicIcon />
          Multiple {isMultipleFileUploadButton ? "Files" : "Tracks"}
        </MenuItem>
      </StyledMenu>
    </div>
  );
};
